import { status } from '@sportninja/common/constants/attendanceStatus'

// Single source for the attendance status copy shared by the help modal and the
// row tooltips. Mirrors the mobile AttendanceHelpBottomSheet statuses/copy.
export interface AttendanceStatusCopy {
  title: string
  description: string
  // Shorter wording for the row tooltip, where the longer help-modal sentence
  // reads as too much. Falls back to `description` when absent.
  tooltipDescription?: string
}

export const ATTENDANCE_STATUS_COPY: Record<string, AttendanceStatusCopy> = {
  not_attending: {
    title: 'Not Attending',
    description: 'Player is not attending the game',
  },
  maybe_attending: {
    title: 'Maybe Attending',
    description: 'Player is awaiting attendance review',
  },
  attending: {
    title: 'Attending',
    description: 'Player is attending the game',
  },
  injury: {
    title: 'Injury',
    description: 'Player is injured and not attending',
    tooltipDescription: 'Player is injured',
  },
  suspended: {
    title: 'Suspended',
    description: 'Player is suspended from the game',
  },
}

// Spare action tooltips. Promote/withdraw sit on the Eligible Game Spares
// plus/minus icons; demote is reused by the minus icon and by the Roster Spares
// CONFIRM checkbox, both of which reverse an already-granted promotion.
export const PROMOTE_TOOLTIP = 'Promote — Add player to the team roster'
export const WITHDRAW_TOOLTIP = 'Withdraw — Cancel the request'
export const DEMOTE_TOOLTIP = 'Demote — Remove player from the team roster'

// Jersey number cell tooltips.
export const JERSEY_EDIT_TOOLTIP = 'Edit Jersey Number'
export const JERSEY_LOCKED_SUSPENDED_TOOLTIP =
  'Suspended players can’t change their jersey number'
export const JERSEY_LOCKED_WAIVER_TOOLTIP =
  'Waiver not signed — jersey number is locked'

export const getJerseyConflictTooltip = (names: string[]): string =>
  names.length > 0
    ? `Same as ${names.join(', ')} — click to change`
    : 'Duplicate jersey number — click to change'

// Maps an availability icon value to its copy key.
export const ATTENDANCE_STATUS_COPY_KEY_BY_VALUE: Record<number, string> = {
  [status.ATTENDING]: 'attending',
  [status.MAYBE]: 'maybe_attending',
  [status.NOT_ATTENDING]: 'not_attending',
}

export const getAttendanceStatusTooltip = (key: string): string => {
  const copy = ATTENDANCE_STATUS_COPY[key]
  if (!copy) {
    return ''
  }
  return `${copy.title} — ${copy.tooltipDescription ?? copy.description}`
}
